import React from "react";
import { Box, BoxType } from "../../../Box";
import Flex from "../../../Flex";
import * as SC from "./Onboarding.styles";
import ShieldImage from "../../../../assets/shield.svg";
import SpectralLogo from "../../../../assets/spectral.svg";
import { SpectralButton } from "../../../SpectralButton";
import { RightArrowIcon } from "../../../Icon/icons/RightArrow";
import { InfoIcon } from "../../../Icon/icons/Info";
import {
  DialogSteps,
  useDialogStepsContext,
} from "../../../../contexts/DialogStepsContext";

interface OnboardingProps {
  partnerLogo: string;
}

export const Onboarding = ({ partnerLogo }: OnboardingProps) => {
  const { setCurrentStep } = useDialogStepsContext();
  return (
    <SC.OnboardingContainer>
      <SC.OnboardingInformation>
        <Flex column align="center" justify="center">
          <SC.LogoContainer>
            <Flex align="center" width="100%">
              <img src={partnerLogo || SpectralLogo} alt="Partner Logo" />
              <SC.Divider />
              <img src={SpectralLogo} alt="Spectral Logo" />
            </Flex>
          </SC.LogoContainer>
          <h1>Authenticate with Spectral</h1>
          <span>
            Spectral is your on-chain credit scoring system.
            <br />
            <br />
            We analyze the transactions in your wallet and send the lender your
            credit score.
          </span>
        </Flex>
      </SC.OnboardingInformation>
      <Box
        type={BoxType.INFO}
        width="100%"
        height="116px"
        margin="35px 0 28px 0"
      >
        <Flex align="start" justify="center" height="100%">
          <InfoIcon size={24} />
          <SC.OnboardingInfoText>
            We won{"’"}t share your wallet addresses, transaction history or any
            other information with the lender, other than your credit score.
          </SC.OnboardingInfoText>
        </Flex>
      </Box>
      <SC.ViewFAQ onClick={() => setCurrentStep(DialogSteps.FAQ)}>
        <Flex align="center" justify="center" height="100%">
          <img src={ShieldImage} alt="Shield Image" />
          <Flex align="center">
            <span>View FAQ</span>
            <RightArrowIcon />
          </Flex>
        </Flex>
      </SC.ViewFAQ>

      <SpectralButton
        label="Continue"
        width="100%"
        height="56px"
        onClick={() => setCurrentStep(DialogSteps.WALLET_CONNECTION)}
      />
    </SC.OnboardingContainer>
  );
};
